/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InvitationAccept interface.
 */
export function instanceOfInvitationAccept(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('instrumentId' in value) || value['instrumentId'] === undefined)
        return false;
    return true;
}
export function InvitationAcceptFromJSON(json) {
    return InvitationAcceptFromJSONTyped(json, false);
}
export function InvitationAcceptFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'instrumentId': json['instrument_id'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}
export function InvitationAcceptToJSON(json) {
    return InvitationAcceptToJSONTyped(json, false);
}
export function InvitationAcceptToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'instrument_id': value['instrumentId'],
        'code': value['code'],
    };
}
